import { effect, signal, Signal } from '@preact/signals';
import { type OfferData } from 'service/offer/model';
import { type UserData } from 'service/user/model';
import type { PremiseData } from 'service/premise/model';
import type { OfferRooms } from 'service/offer/resource';

type MultiselectOfferSignalData = {
	enabled: boolean;
	selectedOffers: Map<number, OfferData>;
};

export type UserValue = UserData | PremiseData | null;
export const userBazar = signal<UserValue>();
export function isUserData(value?: UserValue): value is UserData {
	return value !== undefined && value !== null && !value.isPremise;
}

export const listingRowView = signal<boolean>(false);

effect(() => {
	if (isUserData(userBazar.value)) {
		listingRowView.value = userBazar.value.settings?.listingRowView ?? false;
	}
});

export class MultiselectOfferSignal extends Signal<MultiselectOfferSignalData> {
	enable() {
		this.value = { ...this.value, enabled: true };
	}

	disable() {
		this.value = { enabled: false, selectedOffers: new Map() };
	}

	add(offer: OfferData) {
		this.value.selectedOffers.set(offer.id, offer);
		this.value = { ...this.value, selectedOffers: this.value.selectedOffers };
	}

	delete(offerId: number) {
		this.value.selectedOffers.delete(offerId);
		this.value = { ...this.value, selectedOffers: this.value.selectedOffers };
	}

	selectAll(offers: OfferData[]) {
		this.value = { ...this.value, selectedOffers: new Map(offers.map((offer) => [offer.id, offer])) };
	}

	unselectAll() {
		this.value = { ...this.value, selectedOffers: new Map() };
	}
}

export const multiselectOffers = new MultiselectOfferSignal({
	enabled: false,
	selectedOffers: new Map(),
});

export const offersAndRooms = signal<OfferRooms[]>([]);
